import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const IntSiteApi = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/Phone`,
  scopes: ExtHubRequest,
});

IntSiteApi.createEntities([{ name: 'getPoliciesForInsuredBySinglePolicy' }]);

const GetPoliciesForInsuredBySinglePolicy = (body) =>
  IntSiteApi.endpoints.getPoliciesForInsuredBySinglePolicy.post(body);

export { GetPoliciesForInsuredBySinglePolicy };
